import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from "./FilterButtons.module.css";
import { useKpiData } from "utils/samarth-dashboard-context/hooks/useKpiData";
import { useSamarthDashboardContext } from "utils/samarth-dashboard-context/hooks/useSamarthDashboardContext";
import clsx from "clsx";

export default function FilterButtons({ showWeeks = true }) {
  const actions = ["BG", "ABCD", "Segmentation", "Format", "Factory", "SmallC"];
  const { resetActionFilter, setActionFilter, setCurrentTDP, setWeekFilter, state } = useSamarthDashboardContext();
  const { filters } = useKpiData();
  const globarView = state.viewMode.globalViewMode;
  const currentWeek = filters.currentWeek;
  const currentTDP = filters.currentTDP;
  const loading = state.dashboardData.isLoading.all;

  const [weekAnchorEl, setWeekAnchorEl] = React.useState(null);
  const [tdpAnchorEl, setTdpAnchorEl] = React.useState(null);

  const tdpToday =  parseInt((state.dashboardData.tdpCurrent || 0)?.replace(
      'TDP ',
      '',
    ));
  const weekToday =  parseInt((state.dashboardData.weekCurrent || 0)?.replace(
      'Week ',
      '',
    ));

  const toggleGlobalFilter = (action) => {
    const isActiveAction = filters.actionFilters?.includes(action);
    isActiveAction ? resetActionFilter() : setActionFilter(action);
  };

  const handleWeekMenuClick = (event) => setWeekAnchorEl(event.currentTarget);
  const handleWeekMenuClose = () => setWeekAnchorEl(null);
  const handleWeekSelect = (week) => {
    setWeekFilter(week);
    handleWeekMenuClose();
  };

  const handleTdpMenuClick = (event) => setTdpAnchorEl(event.currentTarget);
  const handleTdpMenuClose = () => setTdpAnchorEl(null);
  const handleTdpSelect = (tdp) => {
    setCurrentTDP(tdp);
    handleTdpMenuClose();
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.actionsWrapper}>
        {actions.map((action) => (
          <Button
            key={action}
            variant={filters.actionFilters?.includes(action) ? "contained" : "outlined"}
            size="small"
            className={clsx(styles.actionButton)}
            onClick={() => toggleGlobalFilter(action)}
            disabled={loading}
          >
            {action}
          </Button>
        ))}
      </Box>

      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "10px"
      }}>
      {globarView === "graph" && showWeeks && (
        <>
          <Button
            className={styles.dropdownTrigger}
            onClick={handleWeekMenuClick}
            endIcon={<ExpandMoreIcon />}
          >
            Weeks
          </Button>
          <Menu anchorEl={weekAnchorEl} open={Boolean(weekAnchorEl)} onClose={handleWeekMenuClose}>
            {Array.from({ length: 4 }, (_, i) => `Week ${weekToday + i}`).map((week) => (
              <MenuItem
                key={week}
                selected={currentWeek === week}
                onClick={() => handleWeekSelect(week)}
              >
                {week}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}

      {globarView === "graph" && showWeeks && (
        <>
          <Button
            className={styles.dropdownTrigger}
            onClick={handleTdpMenuClick}
            endIcon={<ExpandMoreIcon />}
          >
            TDP
          </Button>
          <Menu anchorEl={tdpAnchorEl} open={Boolean(tdpAnchorEl)} onClose={handleTdpMenuClose}>
            {Array.from({ length: 4 }, (_, i) => `TDP ${tdpToday - (3 - i)}`).map((tdp) => (
              <MenuItem
                key={tdp}
                selected={currentTDP === tdp}
                onClick={() => handleTdpSelect(tdp)}
              >
                {tdp}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
      </div>
    </Box>
  );
}
